import useBodyScrollLock from '../hooks/useBodyScrollLock';

// Phone-only bottom sheet: dark backdrop, rounded top panel sliding over the
// tab bar, internal scroll bounded to 80% of the viewport. Secondary detail
// (gate lists, horizon breakdowns) lives here on mobile instead of a side
// panel.
export default function MobileBottomSheet({ open, onClose, title, children }) {
  useBodyScrollLock(open);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden" role="dialog" aria-modal="true">
      <div
        data-testid="sheet-backdrop"
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />
      <div
        className="absolute inset-x-0 bottom-0 overflow-y-auto overscroll-contain rounded-t-2xl bg-surface dark:bg-gray-870 p-4 pb-[max(env(safe-area-inset-bottom),1rem)] shadow-xl"
        // Bounded so a tall sheet never reaches under the playground banner
        // (fixed, z-60); the var is 0 outside the playground.
        style={{ maxHeight: 'calc(80vh - var(--playground-banner-height, 0px))' }}
      >
        <div
          className="mx-auto mb-3 h-1 w-9 rounded-full bg-gray-300 dark:bg-gray-600"
          aria-hidden="true"
        />
        {title && (
          <h2 className="mb-3 text-sm font-semibold text-gray-900 dark:text-gray-100">{title}</h2>
        )}
        {children}
      </div>
    </div>
  );
}
